import { render, staticRenderFns } from "./stu-service-setting.vue?vue&type=template&id=7f2bdc85&scoped=true"
import script from "./stu-service-setting.vue?vue&type=script&lang=js"
export * from "./stu-service-setting.vue?vue&type=script&lang=js"
import style0 from "./stu-service-setting.vue?vue&type=style&index=0&id=7f2bdc85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2bdc85",
  null
  
)

export default component.exports